import { useTranslation } from "react-i18next";

function DescriptionSampleTip() {
  const { t } = useTranslation();

  return (
    <p
      className="description-sample-tip"
      style={{
        backgroundColor: "#ffff00",
        color: "#111827",
        fontWeight: 700,
        padding: "10px 12px",
        marginBottom: "16px",
        borderRadius: 4,
        textAlign: "left",
        lineHeight: 1.45,
      }}
    >
      {t("description_sample_tip")}
    </p>
  );
}

export default DescriptionSampleTip;
